module.exports = __webpack_public_path__ + "static/media/TreinadorAritmetico.ab2b8178.png";